import { api, apis, ProductAuthorityFeature, COPIED_ATTACH_KEY, } from 'api';
import { escapeRegExp } from '@web-contact/util';
import Alert from '@web-common/components/UI/Alert/Alert';
import { getIfHaveAuth } from '@web-common/utils/utils';
import { overLimitLabel, totalOverLimitLabel } from '@web-common/utils/cloundAttLimit';
import debounce from 'lodash/debounce';
import { message } from 'antd';
import dayjs from 'dayjs';
import { emailPattern } from '@web-common/utils/constant';
import { getIn18Text } from 'api';
import store from '@web-common/state/createStore';
import { MailActions } from '@web-common/state/reducer';
import { createAccountEmailKey } from '@web-common/components/util/contact';
const mailPlusCustomerApi = api.requireLogicalApi(apis.mailPlusCustomerApiImpl);
const htmlApi = api.requireLogicalApi(apis.htmlApi);
const mailApi = api.requireLogicalApi(apis.mailApiImpl);
const dataTrackerApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const mailConfApi = api.requireLogicalApi(apis.mailConfApiImpl);
const productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
const eventApi = api.getEventApi();
const storeApi = api.getDataStoreApi();
export function highlightText(originText = '', searchTerm = '', hitStyle, options = {}) {
    const text = htmlApi.encodeHtml(originText);
    const { hitGlobal, splitSearchTerm = false } = options;
    if (!searchTerm || !text) {
        return text;
    }
    let matchTerm;
    if (splitSearchTerm) {
        matchTerm = [...escapeRegExp(searchTerm)].reduce((prev, curr) => `${prev}|${curr}`);
    }
    else {
        matchTerm = escapeRegExp(searchTerm);
    }
    try {
        const reg = new RegExp(`(${matchTerm})`, hitGlobal ? 'ig' : 'i');
        const replacer = `<span class="${hitStyle}">$1</span>`;
        return text.replace(reg, replacer);
    }
    catch (ex) {
        return text;
    }
}
const userAgentDisplayNone = [
    'head',
    'title',
    'meta',
    'script',
    'style',
    'link',
    'object',
    'iframe',
    'embed',
    'param',
    'source',
    'track',
    'area',
    'base',
    'col',
    'command',
    'keygen',
    'menuitem',
    'hr',
    'progress',
    'meter',
    'fieldset',
    'legend',
    'output',
    'canvas',
    'audio',
    'video',
    'picture',
    'source',
    'template',
];
export const mailHiddenText = (content, format = 'text') => {
    var _a;
    if (!content)
        return;
    let ele = content;
    if (format === 'text' && typeof content === 'string') {
        content;
        var parser = new DOMParser();
        ele = parser.parseFromString(content, 'text/html').body;
    }
    const eleList = [ele];
    const hiddenEles = [];
    while (eleList.length > 0) {
        const item = eleList.pop();
        if (item.id && ['isForwardContent', 'isReplyContent'].includes(item.id))
            continue;
        const itemStyle = window.getComputedStyle(item);
        if (itemStyle.display === 'none' ||
            itemStyle.opacity === '0' ||
            ['collapse', 'hidden'].includes(itemStyle.visibility) ||
            (['absolute', 'relative', 'fixed'].includes(itemStyle.position) &&
                [parseInt(itemStyle.top), parseInt(itemStyle.right), parseInt(itemStyle.bottom), parseInt(itemStyle.left)].some(num => Math.abs(num) > 2000)) ||
            (['absolute', 'fixed'].includes(itemStyle.position) && itemStyle.clip === 'rect(0px, 0px, 0px, 0px)') ||
            (itemStyle.overflow === 'hidden' && (itemStyle.height === '0px' || itemStyle.width === '0px'))) {
            if (userAgentDisplayNone.includes(item.tagName.toLowerCase()))
                continue;
            item.classList.add('hidden-ele-write-mail');
            hiddenEles.push(item);
            continue;
        }
        if ((_a = item === null || item === void 0 ? void 0 : item.children) === null || _a === void 0 ? void 0 : _a.length) {
            for (let i = 0; i < item.children.length; i++) {
                eleList.push(item.children[i]);
            }
        }
    }
    return hiddenEles.reduce((prev, curr) => prev + curr.innerText, '').trim();
};
const freeUpgradeEvent = debounce((currentMailId) => {
    currentMailId &&
        eventApi.sendSysEvent({
            eventName: 'upgradeVersion',
            eventData: { cid: currentMailId },
        });
}, 100);
const versionSpaceLimit = { free: 1, ultimate: 3, education: 3, sirius: 5 };
export const preUploadAttachment = (params) => {
    var _a, _b, _c, _d;
    const { fileList, currentMailId, currentMailSize, cloudAttInfo, _account = '', flag = { usingCloud: false } } = params;
    const { usingCloud } = flag;
    const productVersionId = productAuthApi.doGetProductVersionId();
    const limit = (_a = versionSpaceLimit[productVersionId]) !== null && _a !== void 0 ? _a : 3;
    const versionalSingleSizeLimit = limit * 1024 * 1024 * 1024;
    const mailLimit = mailConfApi.getMailLimit({ _account });
    let filesTotalSize = 0;
    const fileListAry = [];
    for (let originFile of fileList) {
        const { name: originFileName, size: originFileSize } = originFile;
        const file = {
            id: `${originFileName}_${new Date().getTime()}_${Math.random()}`,
            mailId: currentMailId,
            file: originFile,
            flag: flag,
            type: 'upload',
            fileName: originFileName,
            fileSize: originFileSize,
            realId: mailApi.generateRndId(),
        };
        if (usingCloud) {
            if (originFileSize > versionalSingleSizeLimit) {
                Alert.error({
                    title: getIn18Text('YUNFUJIANDAODA'),
                    content: (_b = overLimitLabel[productVersionId]) !== null && _b !== void 0 ? _b : overLimitLabel['sirius'],
                });
                return;
            }
            filesTotalSize += originFileSize;
        }
        const allsize = currentMailSize + originFileSize;
        if (allsize > mailLimit.upload_total_size || originFileSize > mailLimit.upload_size) {
            if (!usingCloud) {
                if (getIfHaveAuth(ProductAuthorityFeature.ORG_SETTING_BIG_ATTACH_SHOW)) {
                    message.info(getIn18Text('WENJIANGUODA\uFF0C'));
                }
                else {
                    if (productVersionId === 'free') {
                        freeUpgradeEvent(currentMailId);
                    }
                    else {
                        message.info(getIn18Text('WENJIANGUODA100'));
                    }
                    continue;
                }
            }
            file.cloudAttachment = true;
            filesTotalSize += originFileSize;
            if (usingCloud && originFileSize > versionalSingleSizeLimit) {
                Alert.error({
                    title: getIn18Text('YUNFUJIANDAODA'),
                    content: (_c = overLimitLabel[productVersionId]) !== null && _c !== void 0 ? _c : overLimitLabel['sirius'],
                });
                return;
            }
        }
        if ((usingCloud || file.cloudAttachment) && cloudAttInfo && cloudAttInfo.sizeLimit - cloudAttInfo.totalSize < filesTotalSize) {
            Alert.error({
                title: getIn18Text('YUNFUJIANDAODA'),
                content: (_d = totalOverLimitLabel[productVersionId]) !== null && _d !== void 0 ? _d : totalOverLimitLabel['sirius'],
            });
            return;
        }
        fileListAry.push(file);
    }
    return fileListAry;
};
export const prePasteAttachment = async (params) => {
    var _a, _b;
    const { currentMail, currentMailSize } = params;
    const { suc, data: copiedDataStr } = storeApi.getSync(COPIED_ATTACH_KEY);
    const _account = currentMail.initSenderStr || '';
    try {
        if (suc && copiedDataStr) {
            const file = JSON.parse(copiedDataStr);
            const { timestamp } = file;
            const formatStr = 'YYYY-MM-DD';
            const formatSaved = dayjs(timestamp).format(formatStr);
            const formatNow = dayjs().format(formatStr);
            if (formatSaved !== formatNow) {
                message.error('附件失效');
                return;
            }
            const { cloudAttachment, fileSize } = file;
            const productVersionId = productAuthApi.doGetProductVersionId();
            const limit = (_a = versionSpaceLimit[productVersionId]) !== null && _a !== void 0 ? _a : 3;
            const versionalSingleSizeLimit = limit * 1024 * 1024 * 1024;
            const mailLimit = mailConfApi.getMailLimit({ _account });
            if (cloudAttachment) {
                if (fileSize > versionalSingleSizeLimit) {
                    Alert.error({
                        title: getIn18Text('YUNFUJIANDAODA'),
                        content: (_b = overLimitLabel[productVersionId]) !== null && _b !== void 0 ? _b : overLimitLabel['sirius'],
                    });
                    return;
                }
            }
            else {
                const allsize = currentMailSize + fileSize;
                if (allsize > mailLimit.upload_total_size || fileSize > mailLimit.upload_size) {
                    message.info(getIn18Text('WENJIANGUODA100'));
                    return;
                }
            }
            return file;
        }
        else {
            message.error('请先复制附件');
            return;
        }
    }
    catch (error) {
        console.log('pasteAtt error', error);
        return;
    }
};
export const updateCopiedAtt = async (params) => {
    var _a;
    const { suc, data: copiedDataStr } = storeApi.getSync(COPIED_ATTACH_KEY);
    try {
        if (suc && copiedDataStr) {
            const file = JSON.parse(copiedDataStr);
            if (((_a = params) === null || _a === void 0 ? void 0 : _a.copyAttId) !== file.copyAttId)
                return;
            const newFile = Object.assign(Object.assign({}, file), params);
            storeApi.putSync(COPIED_ATTACH_KEY, JSON.stringify(newFile));
        }
    }
    catch (error) {
        console.log('updateCopiedAtt error', error);
        return;
    }
};
export function highlightName(textToSearch, hitQuery = [], searchTerm, hitStyle) {
    let html = textToSearch;
    const hit = hitQuery && (['contactName', 'contactPYName'].some((query) => hitQuery === null || hitQuery === void 0 ? void 0 : hitQuery.includes(query)) || hitQuery.includes('owner'));
    if (searchTerm && hit) {
        html = highlightText(html, searchTerm, hitStyle);
    }
    return html;
}
export function highlightEmail(textToSearch = '', contactInfo = [], searchTerm, hitStyle) {
    let html = textToSearch;
    const hits = contactInfo.filter((info) => { var _a; return (info === null || info === void 0 ? void 0 : info.hitQuery) && (info === null || info === void 0 ? void 0 : info.contactItemType) === 'EMAIL' && ((_a = info === null || info === void 0 ? void 0 : info.hitQuery) === null || _a === void 0 ? void 0 : _a.includes('contactItemVal')); });
    if (searchTerm && html) {
        html = highlightText(html, searchTerm, hitStyle);
    }
    return html;
}
export function verifyEmail(email) {
    const emailReg = emailPattern;
    const result = emailReg.test(email);
    if (!result) {
        try {
            dataTrackerApi.track('email_verification_failed', { email });
        }
        catch (error) {
            console.log('verifyEmail failed:', error);
        }
    }
    return result;
}
export const remWaittingId = (id, remark) => {
    var _a, _b;
    if (!id)
        return;
    const waittingMailIds = (_b = (_a = store.getState()) === null || _a === void 0 ? void 0 : _a.mailReducer) === null || _b === void 0 ? void 0 : _b.waittingMailIds;
    if (waittingMailIds === null || waittingMailIds === void 0 ? void 0 : waittingMailIds.includes(id)) {
        store.dispatch(MailActions === null || MailActions === void 0 ? void 0 : MailActions.doRemWaittingMailId(id));
        if (remark) {
            message.error({ content: getIn18Text('ZIDONGFASONGZHONGD，QBJWCHCXFS') });
        }
    }
};
export const getStoreBooleanData = (key) => {
    const res = storeApi.getSync(key);
    if (res.suc && res.data) {
        return Boolean(res.data);
    }
    return false;
};
export const transEdmSendConflict = (list) => {
    const res = {};
    list.forEach(item => {
        if (item.module == 0) {
            res.colleagueCustomer = !!item.colleagueCustomer;
            res.colleagueClue = !!item.colleagueClue;
        }
    });
    return res;
};
export const isInvalidSendMailReceiver = (params) => {
    const { receivers, emailIdMap, contactMap, options } = params;
    const res = receivers.some(item => {
        var _a, _b;
        const email = (_a = item === null || item === void 0 ? void 0 : item.contactItem) === null || _a === void 0 ? void 0 : _a.contactItemVal;
        if (!email) {
            return true;
        }
        const emailKey = createAccountEmailKey(email, (_b = item === null || item === void 0 ? void 0 : item.contact) === null || _b === void 0 ? void 0 : _b._account);
        const contactId = emailIdMap[emailKey];
        const contactModel = contactMap[contactId];
        return isInvalidRoleContactModel(contactModel, options);
    });
    return res;
};
export const isInvalidRoleContactModel = (contactModel, options) => {
    var _a;
    const role = (_a = contactModel === null || contactModel === void 0 ? void 0 : contactModel.customerOrgModel) === null || _a === void 0 ? void 0 : _a.role;
    if (!role) {
        return false;
    }
    return !!options[trimNoAuthRole(role)];
};
export const isInvalidRoleContactItem = (item, options) => {
    const role = item === null || item === void 0 ? void 0 : item.customerRole;
    if (!role) {
        return false;
    }
    return !!options[trimNoAuthRole(role)];
};
export const getEdmSendConflictConfig = () => {
    const config = mailPlusCustomerApi.doGetEdmSendMailConflictConfig();
    const options = transEdmSendConflict(config);
    return options;
};
export const getSendMailReceiverRoleByEmails = async (emails) => {
    const config = await mailPlusCustomerApi.doGetEdmSendMailConflictConfigForce();
    const options = transEdmSendConflict(config);
    const emailRole = await mailPlusCustomerApi.doGetRoleByEmail({
        emails,
        useEdm: process.env.BUILD_ISEDM,
    });
    return emails.some(email => {
        var _a;
        const role = (_a = emailRole[email]) === null || _a === void 0 ? void 0 : _a.role;
        return role && !!options[trimNoAuthRole(role)];
    });
};
export const trimNoAuthRole = (role) => {
    return role.replace('NoAuth', '');
};
